import isString from 'lodash/isString';
import isFunction from 'lodash/isFunction';
import includes from 'lodash/includes';
//
import { WEB, PACT } from '../../constants/applicationTypeConstants';
import {
  URL_CONFIGURATION,
  URL_FEATURES,
  URL_WEB_HANDOVER,
  URL_APPS_HANDOVER,
} from '../../constants/endpointConstants';
import { REFRESHING_APPS_ACCESS_TOKEN } from '../../constants/actionConstants';
import appConstants from '../../constants/appConstants';

async function getWebAuthorizationHeader() {
  try {
    const browserAccessToken = await window.Auth0Client.getTokenSilently({
      timeoutInSeconds: appConstants.AUTH0_TOKEN_TIMEOUT,
    });
    if (isString(browserAccessToken)) {
      return {
        Authorization: `Bearer ${browserAccessToken}`,
      };
    }
  } catch (err) {
    // fail silently so as not to interrupt API call
  }

  return {};
}

async function getAppsAuthorizationHeader(params) {
  const {
    getState,
    dispatch,
  } = params;

  if (!getState().mobileApps?.refreshingAppsAccessToken) {
    const requestAccessToken = getState().mobileApps?.requestAccessToken;
    if (isFunction(requestAccessToken)) {
      // TODO investigate why we have both REFRESHING_APPS_ACCESS_TOKEN and APPS_REFRESH_ACCESS_TOKEN_REQUESTED
      dispatch({
        type: REFRESHING_APPS_ACCESS_TOKEN,
      });

      // requests that the app gives us an up to date token, received in mobileAppsReducer
      requestAccessToken();
    }
  }

  const auth0AccessToken = getState().mobileApps?.auth0AccessToken;
  if (auth0AccessToken) {
    return {
      Authorization: `Bearer ${auth0AccessToken}`,
    };
  }

  return {};
}

export default async function getAuthorizationHeader(params) {
  const {
    path,
    getState,
  } = params;

  const ignorePaths = [URL_FEATURES, URL_CONFIGURATION, URL_WEB_HANDOVER, URL_APPS_HANDOVER];

  if (includes(ignorePaths, path)) {
    return {};
  }

  const isGuest = getState().user?.isGuest;
  if (isGuest) {
    return {};
  }

  const webAuthorizationHeaderApplications = [WEB, PACT];
  const applicationType = getState().app?.applicationType;
  if (webAuthorizationHeaderApplications.includes(applicationType)) {
    return getWebAuthorizationHeader();
  }

  if (!webAuthorizationHeaderApplications.includes(applicationType)) {
    return getAppsAuthorizationHeader(params);
  }

  return {};
}
